import { routes } from '@/config/routes';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

function RedirectToHomePage() {
  const router = useRouter();
  
  useEffect(() => {
    router.push(routes.home);
  }, [router]);
  
  return null;
}

RedirectToHomePage.auth = {};

export default RedirectToHomePage;
